/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { V1OverviewByDriversModel } from '../../entities/v1/OverviewByDriversModel'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { z } from 'zod'

export const v1OverviewByDriversModelSchema = z.object({
  company_reward: z.number(),
  drivee_commission: z.number(),
  drivers_revenue: z.number(),
  total_drivers: z.number().int(),
  total_orders: z.number().int(),
}) as unknown as ToZod<V1OverviewByDriversModel>